import { Typography } from "@material-ui/core";
import { InfoItem } from "../contacts/WatchContactPage";
import { DefaultTextField } from "../customers/EditCustomerPage";


export default function DevelopmentTab({ project, setProject }) {
    const infoDev = project?.infoStatus;

    const Permitting = () => {
        return (
            <>
                <div className="d-flex align-item-center mt-5 flex-column">
                    <Typography variant="h6" color="text.secondary">
                        Permitting
                    </Typography>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Preliminary Administrative Authorization" value={infoDev?.preAdminPermit} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Construction Administrative Permit " value={infoDev?.constAdminPermit} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Transformer station/substation Permit " value={infoDev?.transformerPermition} h6 />
                    </div>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Environmental Permit " value={infoDev?.envStatus} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Environment Impact Assessment (EIA) " value={infoDev?.envImpacAsses} h6 />
                    </div>

                </div>
                <div className="d-flex align-item-center">
                    <div className="col-12">
                        {project?.status !== "review" ?
                            <InfoItem label="Observations" value={infoDev?.observationEnv} h6 />
                            :
                            (
                                <>
                                    < Typography variant={"h6"} style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: "12px" }}>
                                        Observations
                                    </Typography>

                                    <DefaultTextField value={infoDev?.observationEnv}
                                        onChange={(e) => {
                                            setProject({
                                                ...project,
                                                infoStatus: {
                                                    ...project.infoStatus,
                                                    observationEnv: e.target.value
                                                }
                                            });
                                        }}
                                        required={false} multiline rows={4}
                                    />

                                </>
                            )}

                    </div>
                </div >
            </>
        );
    }

    const LandRigths = () => {
        return (
            <>
                <div className="d-flex align-item-center mt-5 flex-column">
                    <Typography variant="h6" color="text.secondary">
                        Land Rights
                    </Typography>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Land Rights Status: " value={infoDev?.landStatus} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Type of Land Rights: " value={infoDev?.typeLand} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Area: " value={infoDev?.areaHectars + ' ha'} h6 />
                    </div>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Number of Landowners: " value={infoDev?.numLandOwners} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Duration of Right: " value={infoDev?.landLeaseDuration + ' years'} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Percentage of land secured: " value={infoDev?.percLand + ' %'} h6 />
                    </div>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Annual Lease price: " value={infoDev?.landLeasePriceYear !== undefined ? infoDev?.landLeasePriceYear + ' €/ha/year' : '---'} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Other Payments/compensations: " value={infoDev?.otherPayComp} h6 />
                    </div>

                </div>
                <div className="d-flex align-item-center">
                    <div className="col-12">
                        {project?.status !== "review" ?
                            <InfoItem label="Observations" value={infoDev?.observationLand} h6 />
                            :
                            (
                                <>
                                    < Typography variant={"h6"} style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: "12px" }}>
                                        Observations
                                    </Typography>

                                    <DefaultTextField value={infoDev?.observationLand}
                                        onChange={(e) => {
                                            setProject({
                                                ...project,
                                                infoStatus: {
                                                    ...project.infoStatus,
                                                    observationLand: e.target.value
                                                }
                                            });
                                        }}
                                        required={false} multiline rows={4}
                                    />
                                </>
                            )}
                    </div>
                </div >
            </>
        );
    }

    const GridConnection = () => {
        return (
            <>
                <div className="d-flex align-item-center mt-5 flex-column">
                    <Typography variant="h6" color="text.secondary">
                        Grid Connection
                    </Typography>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Grid Connection Status " value={infoDev?.gridStatus} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Approved/ Expected Connection date " value={infoDev?.interconnectionAgreement} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Transmission system owner " value={infoDev?.transmissionSystemOwner} h6 />
                    </div>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Connection type " value={infoDev?.conectionType} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Connection Line length " value={infoDev?.lineDistance !== undefined ? infoDev?.lineDistance + ' km' : '---'} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Interconnection Voltage " value={infoDev?.interconnectionVoltage !== undefined ? infoDev?.interconnectionVoltage + ' kv' : '---'} h6 />
                    </div>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Approved export capacity " value={infoDev?.approvedExportCapacity !== undefined ? infoDev?.approvedExportCapacity + ' MWac' : '---'} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Grid Connection Cost " value={infoDev?.gridConnectionCost !== undefined ? infoDev?.gridConnectionCost + ' k€/MW' : '---'} h6 />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Grid Connection Access (IVA) " value={infoDev?.gridConnectionIva !== undefined ? infoDev?.gridConnectionIva + ' k€/MW' : '---'} h6 />
                    </div>

                </div>
                <div className="d-flex align-item-center">
                    <div className="col-12">
                        {project?.status !== "review" ?
                            <InfoItem label="Observations" value={infoDev?.observationGrid} h6 />
                            :
                            (
                                <>
                                    < Typography variant={"h6"} style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: "12px" }}>
                                        Observations
                                    </Typography>

                                    <DefaultTextField value={infoDev?.observationGrid}
                                        onChange={(e) => {
                                            setProject({
                                                ...project,
                                                infoStatus: {
                                                    ...project.infoStatus,
                                                    observationGrid: e.target.value
                                                }
                                            });
                                        }}
                                        required={false} multiline rows={4}
                                    />

                                </>
                            )}
                    </div>
                </div >
            </>
        );
    }

    return (
        <>
            {Permitting()}
            {LandRigths()}
            {GridConnection()}

        </>
    )
}